// @mui
import { Box, Breadcrumbs, Link, Stack, Typography } from '@mui/material';

//
import type { CustomBreadcrumbsProps } from './types';

import LinkItem from './LinkItem';

// ----------------------------------------------------------------------

const CustomBreadcrumbs = ({
  action,
  activeLast,
  heading,
  links,
  moreLink,
  sx,
  ...other
}: CustomBreadcrumbsProps) => {
  const lastLink = links.length > 0 ? links[links.length - 1].name : '';

  return (
    <Box sx={{ mb: 5, ...sx }}>
      <Stack alignItems="center" direction="row">
        <Box sx={{ flexGrow: 1 }}>
          {/* HEADING */}
          {heading && (
            <Typography gutterBottom variant="h4">
              {heading}
            </Typography>
          )}

          {/* BREADCRUMBS */}
          {!!links.length && (
            <Breadcrumbs separator={<Separator />} {...other}>
              {links.map((link) => (
                <LinkItem
                  activeLast={activeLast}
                  disabled={link.name === lastLink}
                  key={link.name || ''}
                  link={link}
                />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}> {action} </Box>}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link
              href={href}
              key={href}
              noWrap
              rel="noopener"
              sx={{ display: 'table' }}
              target="_blank"
              variant="body2"
            >
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomBreadcrumbs;

const Separator = () => {
  return (
    <Box
      component="span"
      sx={{
        bgcolor: 'text.disabled',
        borderRadius: '50%',
        height: 4,
        width: 4,
      }}
    />
  );
};
